import React, { useState, useEffect, useCallback } from 'react'
import ClickOutHandler from 'react-onclickout'
import { useDispatch } from 'react-redux'

import DisplayButtons from './DisplayButtons'
import { apiUsers } from 'api'
import { success as userSuccessAct } from 'redux/actions/conversations/user'

const CodClient = (props) => {
  const { jsonKey, value, ticketId, onUpdateUser } = props

  const dispatch = useDispatch()
  const [text, setText] = useState('')
  const [readOnly, setReadOnly] = useState(true)
  const [sending, setSending] = useState(false)

  useEffect(() => {
    if (readOnly) {
      setText(value)
    }
  }, [value, readOnly])

  const onResetValue = useCallback(() => {
    if (!readOnly) {
      setReadOnly(true)
      setText(value)
    }
  }, [readOnly, value])

  const onSubmit = (e) => {
    e.stopPropagation()

    setReadOnly(true)
    setSending(true)

    apiUsers
      .externalUpdate({ value: text, key: jsonKey, ticketId })
      .then(({ data }) => {
        onUpdateUser(data.results)
        dispatch(userSuccessAct(data.results))
        setSending(false)
      })
      .catch(() => setSending(false))
  }

  const onKeyPress = (e) => {
    e.stopPropagation()

    if (e.key === 'Enter') onSubmit(e)
  }

  return (
    <div className='seccion-one'>
      <label>Código cliente</label>

      <ClickOutHandler onClickOut={onResetValue}>
        {/* <Col sm='8 position-relative'> */}
        <div className='cod_client'>
          <input
            className={`cod_client${readOnly ? '-not_edit' : '-edit'}`}
            readOnly={readOnly}
            type='text'
            name='metadata.codcliente'
            placeholder='Código de cliente'
            value={text}
            onChange={({ target }) => setText(target.value || '')}
            onDoubleClick={() => setReadOnly(false)}
            onKeyPress={onKeyPress}
          />

          <DisplayButtons
            readOnly={readOnly}
            sending={sending}
            onResetValue={onResetValue}
            onSubmit={onSubmit}
            onEdit={() => setReadOnly(false)}
          />
        </div>
        {/* </Col> */}
      </ClickOutHandler>
    </div>
  )
}

export default CodClient
